import { useParams, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CategoryHero from './components/CategoryHero';
import VideoGrid from './components/VideoGrid';
import { categories, videos } from '@/mocks/videos';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  useEffect(() => {
    if (category) {
      document.title = `${category.name} - 吃瓜视频 | 独家吃瓜爆料视频专区`;
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute(
          'content',
          `${category.name}专区 - 全网独家${category.name}吃瓜爆料视频。${category.description}，免费吃瓜视频下载观看，网红翻车明星八卦一触即发！`
        );
      }
    }
  }, [category]);

  if (!category) {
    return <Navigate to="/" replace />;
  }

  const videoCount = videos.filter((v) => v.category === slug).length;

  return (
    <>
      <Navbar />
      <main>
        <CategoryHero
          name={category.name}
          description={category.description}
          icon={category.icon}
          slug={category.slug}
          videoCount={videoCount}
        />
        <VideoGrid categorySlug={category.slug} />
      </main>
      <Footer />
    </>
  );
}